import React from 'react';

import Label from './controls/label';
import type { IProps as ILabelProps } from './controls/label';

export interface IProps extends ILabelProps {
  placeholder?: string;
  value?: string;
}

const Readonly: React.FC<IProps> = React.memo(
  ({ hideLabel, isMarkdown, inline, placeholder, value }) => {
    const display = React.useMemo(() => {
      return value || placeholder || 'Not Specified';
    }, [placeholder, value]);

    const style = React.useMemo<React.CSSProperties>(() => {
      const style: React.CSSProperties = {
        fontStyle: 'italic',
        borderBottom: '1px solid #90a4ae',
        marginBottom: 5,
        fontFamily: 'maitland'
      };

      if (!value) {
        style.color = '#90a4ae';
      }

      return style;
    }, [value]);

    return (
      <div style={style}>
        <Label hideLabel={hideLabel} inline={inline} isMarkdown={isMarkdown} />
        <div style={{ marginBottom: 5 }}>{display}</div>
      </div>
    );
  }
);

Readonly.displayName = 'Readonly';

export default Readonly;
